import {
  REQUEST_CREATE,
  REQUEST_SUCCESS,
  REQUEST_FAILURE,
  REQUEST_DELETE,
  REQUEST_DELETE_MULTIPLE,
  REQUEST_SUCCESS_MULTIPLE,
  REQUEST_FAILURE_MULTIPLE,
} from './actionTypes';

export function requestCreate({ requestId }) {
  return {
    type: REQUEST_CREATE,
    payload: {
      requestId,
    },
  };
}

export function requestSuccess({ requestId, result }) {
  return {
    type: REQUEST_SUCCESS,
    payload: {
      requestId,
      result,
    },
  };
}

export function requestSuccessMultiple(requestIds) {
  return {
    type: REQUEST_SUCCESS_MULTIPLE,
    payload: {
      requestIds,
    },
  };
}

export function requestFailure({ requestId }) {
  return {
    type: REQUEST_FAILURE,
    payload: {
      requestId,
    },
  };
}

export function requestFailureMultiple(requestIds) {
  return {
    type: REQUEST_FAILURE_MULTIPLE,
    payload: {
      requestIds,
    },
  };
}

export function deleteRequest(requestId) {
  return {
    type: REQUEST_DELETE,
    payload: { requestId },
  };
}

export function deleteMultipleRequests(requestIds) {
  return {
    type: REQUEST_DELETE_MULTIPLE,
    payload: { requestIds },
  };
}
